export default "__VITE_ASSET__b9d52abf__"